import React from "react";

/** Red asterisk for required form fields (Phase 6 form validation). */
export const Req = () => <span className="text-red-500 ml-0.5" aria-hidden="true">*</span>;

/** Input/Textarea classes applied when a required field is missing on submit. */
export const ERR_CLS = "border-red-500 focus-visible:ring-red-500";
